/**
 * WordPress Dependencies
 */
import { __ } from "@wordpress/i18n";
import { assign, isEmpty } from "lodash";
import { select } from "@wordpress/data";
import { addFilter } from "@wordpress/hooks";
import { createHigherOrderComponent } from "@wordpress/compose";
/**
 * Custom Imports
 */
import "./variations";
import variations from "./variations";
import { useEffect } from "@wordpress/element";
import CustomInspectorControls from "./inspector-controls";
import CustomPlaceholder from "./placeholder";
/**
 * Add new attributes to the block
 */
const addAttributes = (props) => {
	const { attributes } = props;

	if (isEmpty(attributes) || props.name !== "core/query") {
		return props;
	}

	props.variations = [...props.variations, ...variations];

	props.attributes = assign(
		props.attributes,
		{
			...attributes,

			gpVariation: {
				type: "string",
				default: "default",
			},

			gutenberghubQcPlaceholder: {
				type: "boolean",
				default: true,
			},

			gutenberghubQcPostCount: {
				type: "number",
				default: 0,
			},

			ghubQcHeight: {
				type: "string",
				default: "500px",
			},

			ghubQcStackOnMobile: {
				type: "boolean",
				default: true,
			},

			ghubQcGap: {
				type: "string",
				default: "10px",
			},
			ghubQcPostLinkTarget: {
				type: "string",
				default: "_self",
			},
			ghubQcIsPostLink: {
				type: "boolean",
				default: true,
			},
		},
		{},
	);

	return props;
};

const withAdvanceControls = createHigherOrderComponent((BlockEdit) => {
	return (props) => {
		const { name } = props;
		const { gpVariation } = props.attributes;

		if (
			name !== "core/query" ||
			(name === "core/query" && "ghub-query-collage" !== gpVariation)
		) {
			return <BlockEdit {...props} />;
		}
		const block = select("core/block-editor").getBlock(props.clientId);
		if (block.innerBlocks.length <= 0) {
			return <BlockEdit {...props} />;
		}

		return (
			<>
				<BlockEdit {...props} />
				<CustomInspectorControls {...props} />
			</>
		);
	};
}, "withAdvanceControls");

const withBlockWrapper = createHigherOrderComponent((BlockListBlock) => {
	return (props) => {
		const {
			gpVariation,
			ghubQcHeight,
			ghubQcGap,
			gutenberghubQcPlaceholder,
			gutenberghubQcPostCount,
			query,
			align,
			ghubQcStackOnMobile,
		} = props.attributes;

		if (
			props.name !== "core/query" ||
			(props.name === "core/query" && "ghub-query-collage" !== gpVariation)
		) {
			return <BlockListBlock {...props} />;
		}

		const block = select("core/block-editor").getBlock(props.clientId);
		if (block.innerBlocks.length <= 0) {
			return <BlockListBlock {...props} />;
		}

		useEffect(() => {
			props.setAttributes({
				query: {
					...query,
					perPage: gutenberghubQcPostCount,
				},
			});
		}, [query?.perPage]);

		const ghubVariables = {
			"--ghub-qc-collage-height": ghubQcHeight,
			"--ghub-qc-collage-gap": ghubQcGap,
		};

		props.wrapperProps = {
			...props.wrapperProps,
			style: ghubVariables,
			className: "ghub-query-wrapper-editor",
		};

		const containerAlign = !isEmpty(align) ? `ghub-qc-${align}` : "";
		const isStackOnMobile = ghubQcStackOnMobile
			? "ghub-qc-stack-on-mobile"
			: "";

		return (
			<div
				className={`ghub-query-collage-container-editor ${containerAlign} ${isStackOnMobile}`}
			>
				{!gutenberghubQcPlaceholder && (
					<BlockListBlock {...props} {...props.wrapperProps} />
				)}

				{gutenberghubQcPlaceholder && (
					<CustomPlaceholder {...props} {...props.wrapperProps} />
				)}
			</div>
		);
	};
}, "withBlockWrapper");

addFilter(
	"editor.BlockEdit",
	"gutenberg-pro-ext/with-advance-controls",
	withAdvanceControls,
);
addFilter(
	"blocks.registerBlockType",
	"gutenberg-pro-ext/add-attributes",
	addAttributes,
);
addFilter(
	"editor.BlockListBlock",
	"gutenberg-pro-ext/with-block-wrapper",
	withBlockWrapper,
);
